import { mlSearchSession } from '../../../shared/utils/mlSearchSession';
import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { createContext } from './createContext';

export function runApp() {
  const context = createContext();

  mlSearchSession.init();

  const store = createApplicationState(context);

  renderApplication({ context, store });
}
